import toast, { ToastOptions } from "react-hot-toast";

const defaultOptions: ToastOptions = {
  duration: 5000,
};

export const toastStore = {
  //
  info: (message: string, options: ToastOptions = defaultOptions) => {
    const toastId = toast(message, options);
    return () => {
      toast.dismiss(toastId);
    };
  },
  success: (message: string, options: ToastOptions = defaultOptions) => {
    const toastId = toast.success(message, options);
    return () => {
      toast.dismiss(toastId);
    };
  },
  warning: (message: string, options: ToastOptions = defaultOptions) => {
    // TODO
    const toastId = toast(message, options);
    return () => {
      toast.dismiss(toastId);
    };
  },
  error: (message: string, options: ToastOptions = defaultOptions) => {
    const toastId = toast.error(message, options);
    return () => {
      toast.dismiss(toastId);
    };
  },
  loading: (message: string, options: ToastOptions = {}) => {
    const toastId = toast.loading(message, options);
    return () => {
      toast.dismiss(toastId);
    };
  },
};
